export default __webpack_public_path__ + "static/media/AntyLucy_13.ecaaeb78.png";